export var defaultMonthOptions = {
    width: 7,
    height: 6
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/_defaults.js
// module chunks = 3